import { FC } from 'react'
import { Tab } from './Tab'

interface TariffsTabsProps {
  currentTab: string
  tabs: string[]
  setTab(tab: string): void
}

export const Tabs: FC<TariffsTabsProps> = ({ tabs, currentTab, setTab }) => {
  return (
    <div className="flex w-full flex-row flex-wrap items-center justify-center gap-x-6 gap-y-4 md:items-baseline md:justify-start md:gap-x-16">
      {tabs.map((tab) => (
        <Tab title={tab} key={tab} isActive={tab === currentTab} setTab={setTab} />
      ))}
    </div>
  )
}
